import React, { useEffect, useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Modal({mState, buttonShow, className, children}) {
    const { t } = useLanguage();
    const [show, setShow] = useState(mState.iShow);

    // Depends on mState.iShow itself, NOT the mState object - callers pass
    // mState={{ iShow, setiShow }} as a fresh object literal on every
    // render, so depending on the object would re-run this on every
    // unrelated parent re-render (e.g. a background socket event) that
    // happens to land while a close animation is still in flight. Since
    // iShow is still true for that whole 1s fadeout, that re-run used to
    // force show back to true mid-animation - flipping the CSS straight
    // from fadeOut back to fadeIn and re-opening the modal the user had
    // just closed (or was closing via a spammed Escape).
    useEffect(()=>{
        if (mState.iShow) setShow(true);
    },[mState.iShow]);

    const closeModal = () => {
        setShow(false);
    }

    const onAnimationEnd = () => {
        if (!show) mState.setiShow(false);
    };

    // Click-outside and Escape both route through the same closeModal ->
    // fadeOut -> onAnimationEnd path as the explicit close button, so there's
    // only one place that actually flips mState.iShow off.
    useEffect(() => {
        if (!mState.iShow) return undefined;
        const onKeyDown = (e) => { if (e.key === 'Escape') closeModal(); };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mState.iShow]);

    return (
        mState.iShow && (
        <>
        <div className="modal-backdrop" style={{ animation: `${show ? "fadeIn" : "fadeOut"} 1s` }} onClick={closeModal} />
        <div
            className={className ? `modal-container ${className}` : "modal-container"}
            style={{ animation: `${show ? "fadeIn" : "fadeOut"} 1s` }}
            onAnimationEnd={onAnimationEnd}
        >
            {children}
            {!buttonShow && <button onClick={closeModal} className="cycloButton primaryColor">{t('common.ok')}</button>}
        </div>
        </>)
    );
}
